import { Avatar, Card, CardHeader, CardContent, Typography, Box, IconButton, Tooltip, Container, Chip } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import theme from "../pages/Theme";

interface Recommendation {
  medication_name: string;
  medication_family: string;
  notes: string[];
}

function CopyIcon({ text }: { text: string }) {
  return (
    <Tooltip title="Copy" placement="top" arrow>
      <IconButton 
        size="small"
        onClick={() => {
          navigator.clipboard.writeText(text);
        }} sx={{ padding: 0 }}>
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default function Recommendation({ recommendation, shadow = true, tag }: { recommendation: Recommendation, shadow?: boolean, tag?: string }) {
  
  return (
    <Card sx={shadow ? { boxShadow:  '0px 4px 12px 0px rgba(0, 0, 0, 0.25)' } : { border: '1px solid #CCC' }}>
      <CardHeader
        sx={{ display: 'flex', alignItems: 'flex-start' }}
        avatar={<Avatar variant="rounded">{recommendation.medication_name[0]}</Avatar>}
        title={
          <Container sx={{ p: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1">{recommendation.medication_name} & Generics</Typography>
            {CopyIcon({ text: recommendation.medication_name })}
          </Box>
          {tag && <Chip label={tag} sx={{ borderRadius: '4px', bgcolor: tag === "BEST" ? theme.pandia.darker_green : '#6d41a1', color: 'white' }} />}
          </Container>
        }
        subheader={recommendation.medication_family}
      />
      {recommendation.notes.length > 0 && (
        <CardContent sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', pt: 0, pb: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Container sx={{ p: 0, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontWeight: 600 }} variant="caption" color="text.secondary">HELPFUL NOTES</Typography>
            {CopyIcon({ text: recommendation.notes.join('\n') })}
          </Container>
          <ul>
              {recommendation.notes.map((note: string, index: number) => (
                <li key={index}>
                  <Typography variant="body2" color="text.secondary">{note}</Typography>
                </li>
              ))}
          </ul>
          </Box>
        </CardContent>
      )}
    </Card>
  )
}